import axios from "axios";

//export default axios.create({baseURL: 'http://192.168.1.169:3500'});

//export default axios.create({baseURL: 'https://crane-cuff-links.cyclic.cloud'})

export default axios.create({baseURL: 'https://ozabackendapi.ozaapp.com'})

//export default axios.create({baseURL: 'https://ozabackendapi.ozaapp.com'})
